;
define("error_management_page_not_found.tpl", function(){});

